let rawAddEventListener: typeof window.addEventListener | null = null;
let rawRemoveEventListener: typeof window.removeEventListener | null = null;

export function getRawAddEventListener(): typeof window.addEventListener {
  if (rawAddEventListener) return rawAddEventListener;

  const Zone = (globalThis as any).Zone;

  const rawEventListener =
    (typeof Zone !== 'undefined' &&
      (window as any)[Zone.__symbol__('addEventListener')]) ||
    window.addEventListener.bind(window);

  rawAddEventListener = rawEventListener;
  return rawEventListener;
}

export function getRawRemoveEventListener(): typeof window.removeEventListener {
  if (rawRemoveEventListener) return rawRemoveEventListener;

  const Zone = (globalThis as any).Zone;

  const rawEventListener =
    (typeof Zone !== 'undefined' &&
      (window as any)[Zone.__symbol__('removeEventListener')]) ||
    window.removeEventListener.bind(window);

  rawRemoveEventListener = rawEventListener;
  return rawEventListener;
}
